<div class="footer" *ngIf="allLabelsForGlobalFooterNav">
    <div class="center-container">
        <div class="container-fluid">
            <div class="row footer-width">
                <div class="col-lg-2 p-lr-zero logo-top-margin">
                    <img src="assets/images/White.png" alt="Footer Vanguard Logo" aria-label="Footer Vanguard Logo"/>
                </div>
            </div>
            <div class="row footer-width">
                <div class="col-lg-10 col-sm-10 p-lr-zero">
                    <span class="footnote">{{allLabelsForGlobalFooterNav['menu-links'][6]['title']}}
                        <a href="/dcrkpublic/#/terms-and-conditions/" target="_blank">
                            {{allLabelsForGlobalFooterNav['menu-links'][0]['title']}}.
                        </a>
                    </span>
                </div>
                <div class="col-lg-2 col-sm-2 feedback-spacing">
                    <button mat-button (click)='onFeedbackNavigate()'
                        class="cancel-button float-right">{{allLabelsForGlobalFooterNav['menu-links'][3]['title']}}</button>
                </div>
            </div>
            <div class="row footer-width footnote-top-margin footer-link-list">
                <div class="col-lg-12 p-lr-zero link-list-spacing-mobile">
                    <ul class="inline-ul link-list-spacing">
                        <li class="inline-ul">
                            <span>
                                <a class="link-list-font" href="{{allLabelsForGlobalFooterNav['menu-links'][1]['absolute']}}" target="_blank">
                                    {{allLabelsForGlobalFooterNav['menu-links'][1]['title']}}
                                </a>
                                <!-- "{{allLabelsForGlobalFooterNav['menu-links'][1]['absolute']}}"  -->
                            </span>
                        </li>
                        <li class="inline-ul">
                            <span class="separator"></span>
                        </li>
                        <li class="inline-ul">
                            <span>
                                <a class="link-list-font" href="{{allLabelsForGlobalFooterNav['menu-links'][7]['absolute']}}" target="_blank">
                                    {{allLabelsForGlobalFooterNav['menu-links'][7]['title']}}
                                </a>
                            </span>
                        </li>
                        <li class="inline-ul">
                            <span class="separator"></span>
                        </li>
                        <li class="inline-ul">
                            <span>
                                <a class="link-list-font" href="{{allLabelsForGlobalFooterNav['menu-links'][2]['absolute']}}" target="_blank">
                                    {{allLabelsForGlobalFooterNav['menu-links'][2]['title']}}
                                </a>
                            </span>
                        </li>
                        <li class="inline-ul">
                            <span class="separator"></span>
                        </li>
                        <li class="inline-ul">
                            <span>
                                <a class="link-list-font" href="{{allLabelsForGlobalFooterNav['menu-links'][4]['absolute']}}" target="_blank">
                                    {{allLabelsForGlobalFooterNav['menu-links'][4]['title']}}
                                </a>
                            </span>
                        </li>
                        <li class="inline-ul">
                            <span class="separator"></span>
                        </li>
                        <li class="inline-ul">
                            <span>
                                <a class="link-list-font" href="{{allLabelsForGlobalFooterNav['menu-links'][5]['absolute']}}" target="_blank">
                                    {{allLabelsForGlobalFooterNav['menu-links'][5]['title']}}
                                </a>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>        
            <div class="col-lg-2 col-sm-2 feedback-spacing-360">
                <button mat-button (click)='onFeedbackNavigate()'
                    class="cancel-button">{{allLabelsForGlobalFooterNav['menu-links'][3]['title']}}</button>
            </div>
        </div>
    </div>
</div>